import React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import MonthArchive from "../../components/newsletter/month-archive"
import { Link, graphql } from 'gatsby'
import { convertTimeToAziaZone } from "../../functions/convert-time-to-azia-timezone"
import "../../styles/pc/page/newsletter_post.scss"
import "../../styles/sp/page/newsletter_post.scss"

export default function NewsletterPost({ data }) {
  const info = data.microcmsNewsletters

  return (
    <Layout>
    <Seo
        type="article"
        title="ニューズレター"
        description=""
        bobyClassName="menu24"
      />
    <div className="wrapper newsletter_post">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/newsletter">Newsletter</Link>　/　<Link to={`/newsletter/${info.newslettersId}`} className="current">{info.title}</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

    <div className="wrapper_contents">
          <div className="main">
    {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
    <div className="contents_01 detail">
      <div className="contents_in">
        <div className="padding_sp">{/* スマホのみ隙間 */}
          {/* <div className="category_title t_left">
            <Link to={'/newsletter/' + convertTimeToAziaZone(info.date,'YYYYMM')}>
              {convertTimeToAziaZone(info.date,'YYYY.MM')}
            </Link>
          </div> */}
          <div className="newsletter_wrapper">
            <div className="newsletter_detail_l">
              <div className="newsletter_list">
                <div className="newsletter_data">{convertTimeToAziaZone(info.date,'YYYY年MM月DD日')}</div>
                <div className="newsletter_title">{info.title}</div>
                <div dangerouslySetInnerHTML={{ __html: info.body}} />
              </div>
            </div>
          <p className="newsletter_txt sp_only">ジェイフィール メールマガジンは楽しい会社、元気な会社、良い仲間に恵まれた会社にするための情報が詰まったメールマガジンです。登録はメールアドレスを入力いただくだけ。ぜひご登録ください！</p>
          <div className="newsletter_entry sp_only"><a href="https://ma.j-feel.jp/NZ_inquiry_lp.html">ニューズレターを受け取る</a></div>
            <MonthArchive />
          </div>
          <p className="newsletter_txt pc_only">ジェイフィール メールマガジンは楽しい会社、元気な会社、良い仲間に恵まれた会社にするための情報が詰まったメールマガジンです。登録はメールアドレスを入力いただくだけ。ぜひご登録ください！</p>
          <div className="newsletter_entry pc_only"><a href="https://ma.j-feel.jp/NZ_inquiry_lp.html">ニューズレターを受け取る</a></div>
        </div>{/* padding_sp スマホのみ隙間 */}
      </div>{/* contents_in */}
    </div>{/* /contents */}
    {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
        </div>{/* main */}
        <div className="page_title fixed">
          <div className="right_page_ttl"><span className="vertical">Newsletter - </span><span className="txt">ニューズレター</span></div>
        </div>{/* right page_title */}
      </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}

export const query = graphql`
query NewsletterIdQuery($id: String!) {
  microcmsNewsletters(newslettersId: {eq: $id}) {
    newslettersId
    title
    body
    date
  }
}`
